// extracted by mini-css-extract-plugin
export default {"Text":"PrivacyPolicy_Text__DXtw3"};